import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

/* 获取充值列表 */
export const getTopUpData = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/company/recharge/${data.companyId}/${data.page}/${data.size}`
  })
}
/* 提交充值 */
export const submitTopUp = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/company/recharge`,
    method: 'post',
    data
  })
}
/* 修改充值  */
export const editDepartment = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/dept`,
    method: 'put',
    data
  })
}
/* 修改充值 */
export const searchTopUp = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/company/recharge/info/${data.orderId}`
  })
}
